import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { MapPin, Phone, Navigation } from 'lucide-react';
export function LocationsSection() {
  const {
    t
  } = useLanguage();
  const locations = [{
    city: 'Allentown',
    state: 'PA',
    address: '2200 Hamilton St #111',
    phone: '484-934-1070',
    mapUrl: 'https://www.google.com/maps/search/?api=1&query=2200+Hamilton+St+%23111+Allentown+PA'
  }, {
    city: 'Bethlehem',
    state: 'PA',
    address: 'Coming Soon',
    phone: '484-934-1070',
    mapUrl: '#'
  }];
  return <section className="py-16 bg-white border-t border-slate-100" id="locations" data-id="element-138">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-139">
        <div className="text-center mb-12" data-id="element-140">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-141">
            {t('Our Locations', 'Nuestras ubicaciones')}
          </h2>
          <p className="text-slate-600" data-id="element-142">
            {t('Serving patients across the Lehigh Valley area.', 'Atendiendo pacientes en toda el área de Lehigh Valley.')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-143">
          {locations.map((loc, index) => <div key={index} className="bg-white rounded-xl overflow-hidden border border-slate-200 shadow-sm hover:shadow-md transition-shadow" data-id="element-144">
              {/* Map Placeholder */}
              <div className="bg-slate-100 h-48 flex items-center justify-center border-b border-slate-100 relative overflow-hidden group" data-id="element-145">
                <MapPin className="w-10 h-10 text-slate-300 mb-2" data-id="element-146" />
                <div className="absolute inset-0 bg-slate-200/50 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-147">
                  <span className="text-slate-600 font-medium text-sm" data-id="element-148">
                    {t('View Map', 'Ver Mapa')}
                  </span>
                </div>
              </div>

              <div className="p-6" data-id="element-149">
                <h3 className="text-xl font-bold text-slate-900 mb-1" data-id="element-150">
                  {loc.city}, {loc.state}
                </h3>
                <p className="text-slate-500 text-sm mb-6 uppercase tracking-wide font-semibold" data-id="element-151">
                  Lehigh Valley Weight Loss
                </p>

                <div className="space-y-4 mb-8" data-id="element-152">
                  <div className="flex items-start" data-id="element-153">
                    <MapPin className="w-5 h-5 text-teal-600 mt-0.5 mr-3 flex-shrink-0" data-id="element-154" />
                    <span className="text-slate-700" data-id="element-155">{loc.address}</span>
                  </div>
                  <div className="flex items-center" data-id="element-156">
                    <Phone className="w-5 h-5 text-teal-600 mr-3 flex-shrink-0" data-id="element-157" />
                    <a href={`tel:${loc.phone.replace(/-/g, '')}`} className="text-slate-700 hover:text-teal-600 transition-colors" data-id="element-158">
                      {loc.phone}
                    </a>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4" data-id="element-159">
                  <a href={`tel:${loc.phone.replace(/-/g, '')}`} className="flex items-center justify-center px-4 py-2 border border-slate-300 rounded-lg text-slate-700 font-medium hover:bg-slate-50 transition-colors text-sm" data-id="element-160">
                    <Phone className="w-4 h-4 mr-2" data-id="element-161" />
                    {t('Call', 'Llamar')}
                  </a>
                  <a href={loc.mapUrl} target="_blank" rel="noreferrer" className="flex items-center justify-center px-4 py-2 bg-slate-900 text-white rounded-lg font-medium hover:bg-slate-800 transition-colors text-sm" data-id="element-162">
                    <Navigation className="w-4 h-4 mr-2" data-id="element-163" />
                    {t('Directions', 'Cómo llegar')}
                  </a>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}